import { ChevronLeft, ChevronRight, RotateCcw } from 'lucide-react'
import { MONTHS_TH, nowYM, stepMonth } from '../../lib/timetable.js'

// Month/year stepper for the year+month-oriented Employee-HR tabs (Leave quota,
// Recurring, Salary). Mirrors the section house style (ring-1 controls, brand
// focus). Clock-in uses a date-range period picker instead — this is the
// month-granular counterpart, not a duplicate.
//
//   <MonthPicker year month onChange={(year, month) => …} showMonth />
//
// showMonth={false} → year-only (annual leave-quota view); the month <select> and
// the ‹ › month steppers are hidden, ‹ › step the year.
// era='BE' (default) shows the Buddhist-era year (+543); era='CE' shows the
// Gregorian year as-is.
const BTN = 'p-2 rounded-lg text-slate-500 ring-1 ring-slate-200 bg-white hover:bg-slate-50 disabled:opacity-40'
const SELECT = 'rounded-xl border border-slate-200 bg-white px-3 py-2 text-[13.5px] text-slate-700 outline-none focus:border-brand-400 focus:ring-4 focus:ring-brand-500/10'

export default function MonthPicker({ year, month = 1, onChange, showMonth = true, era = 'BE' }) {
  const showYear = (y) => (era === 'CE' ? y : y + 543)
  const step = (delta) => {
    if (showMonth) { const n = stepMonth({ year, month }, delta); onChange?.(n.year, n.month) }
    else onChange?.(year + delta, month)
  }
  const reset = () => { const n = nowYM(); onChange?.(n.year, showMonth ? n.month : month) }

  return (
    <div className="flex items-center gap-2">
      <button onClick={() => step(-1)} className={BTN} title={showMonth ? 'เดือนก่อนหน้า' : 'ปีก่อนหน้า'}>
        <ChevronLeft size={15} />
      </button>

      {showMonth && (
        <select value={month} onChange={(e) => onChange?.(year, Number(e.target.value))} className={SELECT}>
          {MONTHS_TH.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
        </select>
      )}

      <select value={year} onChange={(e) => onChange?.(Number(e.target.value), month)} className={SELECT}>
        {yearOptions(year).map((y) => <option key={y} value={y}>{showYear(y)}</option>)}
      </select>

      <button onClick={() => step(1)} className={BTN} title={showMonth ? 'เดือนถัดไป' : 'ปีถัดไป'}>
        <ChevronRight size={15} />
      </button>

      <button onClick={reset} className="inline-flex items-center gap-1.5 px-2.5 py-2 rounded-lg text-[13px] text-slate-500 hover:bg-slate-100" title="กลับไปช่วงปัจจุบัน">
        <RotateCcw size={14} /> ปัจจุบัน
      </button>
    </div>
  )
}

// A small window of selectable years around the current + chosen year.
function yearOptions(chosen) {
  const now = new Date().getFullYear()
  const lo = Math.min(now - 4, Number(chosen) - 1)
  const hi = Math.max(now + 1, Number(chosen) + 1)
  const out = []
  for (let y = hi; y >= lo; y--) out.push(y)
  return out
}
